import i18next from "i18next";

const getCountryText = (country: string) => {
  switch (country) {
    case "DK":
      return i18next.t("imagine:countryDK");
    case "GB":
      return i18next.t("imagine:countryGB");
    case "IE":
      return i18next.t("imagine:countryIE");
    case "NO":
      return i18next.t("imagine:countryNO");
    case "SE":
      return i18next.t("imagine:countrySE");
    case "IT":
      return i18next.t("imagine:countryIT");
    case "US":
      return i18next.t("imagine:countryUS");
    case "MU":
      return i18next.t("imagine:countryMU");
    default: {
      console.error("Unsupported country: " + country);
      return i18next.t("imagine:unknown");
    }
  }
};

const getLanguageText = (language: string) => {
  switch (language) {
    case "da":
      return i18next.t("imagine:danish");
    case "en-US":
      return i18next.t("imagine:englishUS");
    case "en-GB":
      return i18next.t("imagine:englishGB");
    default: {
      console.error("Unsupported language: " + language);
      return i18next.t("imagine:unknown");
    }
  }
};

const getYesNo = (value: boolean | number) => {
  if (value === 1 || value === true) return i18next.t("imagine:yes");
  else return i18next.t("imagine:no");
};

export const I18nText = {
  getCountryText,
  getLanguageText,
  getYesNo,
};
